module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/wishlist-9946c63f3232c1b87bea3ab64e7e377e.svg";